module.exports = __webpack_public_path__ + "static/media/login-image.452da94e.png";